import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";
import { parameter } from "three/src/nodes/core/ParameterNode.js";

function AddSupplier(request_body) {
  return request({

    url: API.SUPPLIERS.CREATE,
    method: requestMethods.POST,
    data: {
      ...request_body
    },

  });
}


function ListSupplier() {
  return request({
    url: API.SUPPLIERS.LIST,
    method: requestMethods.GET
  });
}

function GetSupplierById(id) {
  return request({
    url: `${API.SUPPLIERS.GET_BY}${id}`,
    method: requestMethods.GET

  });
}

function EditSupplier(id, request_body) {
  return request({
    url: `${API.SUPPLIERS.EDIT}${id}`,
    method: requestMethods.PUT,
    data: {
      ...request_body
    },


  });
}
function DeleteSupplier(id) {
  return request({
    url: `${API.SUPPLIERS.DELETE}${id}`,
    method: requestMethods.DELETE,   


  });
}
const SupplierService = {
  AddSupplier,
  ListSupplier,
  GetSupplierById,
  EditSupplier,
  DeleteSupplier
};




export default SupplierService;